"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCurrency = exports.isEmpty = exports.isBlank = void 0;
var util_1 = require("../evaluator/util");
var value_1 = require("../evaluator/value");
exports.isBlank = function (value) {
    if (util_1.isStringValue(value)) {
        return (value.value + "").trim().length === 0;
    }
    else if (util_1.isArrayValue(value)) {
        return value.elements.length <= 0;
    }
    else {
        return false;
    }
};
exports.isEmpty = function (value) {
    if (util_1.isStringValue(value)) {
        return (value.value + "").trim().length === 0;
    }
    else if (util_1.isArrayValue(value)) {
        return value.elements.length <= 0;
    }
    else {
        return false;
    }
};
exports.toCurrency = function (value, decimals) {
    if (decimals === void 0) { decimals = value_1.Value.number(2); }
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var fractionDigits = util_1.coerceNumber(decimals);
    var number = util_1.coerceNumber(value);
    var numberString = number.toString();
    var intCount = numberString.split('.')[0].length;
    var opts;
    if (fractionDigits <= 0) {
        var sigDig = intCount + fractionDigits;
        if (sigDig <= 0) {
            number = 0;
            opts = { maximumFractionDigits: 0 };
        }
        else if (sigDig === 1 && numberString[0] === '0') {
            opts = { maximumFractionDigits: 0 };
        }
        else {
            opts = { maximumSignificantDigits: Math.max(sigDig, 1) };
        }
    }
    else {
        opts = { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits };
    }
    return value_1.Value.string(Intl.NumberFormat('en-US', __assign({ style: 'currency', currency: 'USD' }, opts)).format(number));
};
//# sourceMappingURL=utils.js.map